import {PositionManager} from "./managers/position_manager.js";
import Websocket from "./managers/websocket.js";
import {ModelManager} from "./managers/model_manager.js";
import {authenticateConnection} from "./common/auth.js";
import {RoomManager} from "./managers/room_manager";
import {EntityManager} from "./managers/entity_manager";
import {DialogueManager} from "./managers/dialogue_manager";
import {NPCManager} from "./managers/npc_manager";

export class AlphaBatem {


	deviceType = "unknown";
	deviceHandler = null

	signer

	managers = {
		// "position": new PositionManager(),
		// "entity": new EntityManager(),
		// "connection": new Websocket(),
		// "model": new ModelManager(() => this.onModelsLoaded()),
		// "room": new RoomManager(),
	}


	constructor() {
		this.addManager("position", new PositionManager())
		this.addManager("entity", new EntityManager())
		this.addManager("connection", new Websocket())
		this.addManager("model", new ModelManager(() => this.onModelsLoaded()))
		this.addManager("npc",  new NPCManager())
		this.addManager("room", new RoomManager())
		this.addManager("dialogue", new DialogueManager())
	}

	connectAsDevice(deviceHandler, walletAddr, roomID = null) {
		this.setDeviceHandler(deviceHandler)
		this.setWalletAddr(walletAddr)
		if (roomID !== null)
			this.setRoom(roomID)

		this.init()
	}


	reset() {
		// this.deviceType = "unknown";
		// this.deviceHandler = null
		for (let i = 0; i < this.managers.length; i++) {
			if (this.managers[i].skipReset)
				continue

			this.managers[i].reset()
			delete this.managers[i]
		}

		this.addManager("position", new PositionManager())
		this.addManager("entity", new EntityManager())
		this.addManager("model", new ModelManager(() => this.onModelsLoaded()))
		this.addManager("room",  new RoomManager())
		this.addManager("dialogue",  new DialogueManager())
		this.addManager("npc",  new NPCManager())
	}

	init() {
		this.setHandlers()

		if (this.getConnectionManager().isConnected()) {
			console.log("Initializing - Using Existing WS")
			this.getConnectionManager().bind()
			return
		}

		console.log("Initializing - Starting WS")
		authenticateConnection(
			this.getConnectionManager().getConnectionUUID(),
			this.getConnectionManager().getWalletAddr(),
			this.deviceType,
			(msg) => {
				return this.signMessage(msg)
			},
			(r) => this.onAuthResponse(r)
		)
	}

	onAuthResponse(r) {
		if (!r) {
			console.warn("Unable to authenticate")
			this.getConnectionManager().onDisconnect()
			return
		}

		this.getConnectionManager().connect(this.deviceType)
	}

	/**
	 * Sign the message & return the resulting signature
	 *
	 * @param msg
	 */
	signMessage(msg) {
		if (!this.signer)
			throw new Error("Missing signer")

		return this.signer.sign(msg)
	}

	/**
	 * Setup the signing function for authentication
	 *
	 * @param signer (Must implement sign(msg))
	 */
	setSigner(signer) {
		this.signer = signer
	}

	onModelsLoaded() {
		// this.init()
	}

	addManager(key, manager) {
		this.managers[key] = manager;
	}

	setWalletAddr(walletAddr) {
		this.getConnectionManager().setWalletAddr(walletAddr)
	}

	setRoom(roomID) {
		console.log("Setting Room: ", roomID)
		this.getRoomManager().setRoomID(roomID)
		this.getConnectionManager().setRoomID(roomID)
	}

	setDeviceHandler(handler) {
		console.log("Setting Device Handler: ", handler)
		this.deviceType = handler.getDeviceType();
		this.deviceHandler = handler
	}

	setHandlers() {

		//Position
		this.getConnectionManager().setHandler("player_move", (data) => this.onPlayerMove(data))
		this.getConnectionManager().setHandler("room_join", (data) => this.onPlayerAdd(data))
		this.getConnectionManager().setHandler("room_leave", (data) => this.onPlayerRemove(data))

		//Advertising
		this.getConnectionManager().setHandler("player_animation", (data) => this.onPlayerAnimation(data))

		//Items
		this.getConnectionManager().setHandler("item_add", (data) => this.onItemAdd(data))
		this.getConnectionManager().setHandler("item_remove", (data) => this.onItemRemove(data))


		//Chat
		this.getConnectionManager().setHandler("chat_message", (data) => this.onPlayerChat(data))

		//Mocap
		if (this.managers["mocap"]) {
			this.getConnectionManager().setHandler("player_motion_capture", (data) => this.onPlayerMotionCapture(data)) //TODO?
		}
	}

	getPositionManager() {
		return this.getManager("position")
	}

	getModelManager() {
		return this.getManager("model")
	}

	getConnectionManager() {
		return this.getManager("connection");
	}

	getRoomManager() {
		return this.getManager("room");
	}

	getEntityManager() {
		return this.getManager("entity");
	}

	getDialogueManager() {
		return this.getManager("dialogue")
	}

	getNPCManager() {
		return this.getManager("npc")
	}

	getManager(manager) {
		return this.managers[manager];
	}

	handleHackyAnimationAdvert(data) {
		// const animKey = Static_object.keys(campaignWords)[data.animation_id]
		// addRemoteAdvert(campaignWords[animKey])

		// this.managers["advert"].handleAdvertTrigger(data, this.scene)
		console.log("player_animation (billboard advert): ", data)
	}

	onPlayerAdd(data) {
		console.log("onPlayerAdd: ", data)
	}

	onPlayerRemove(data) {
		console.log("onPlayerRemove: ", data)
	}

	onItemAdd(data) {
		console.log("onItemAdd: ", data)
	}

	onItemRemove(data) {
		console.log("onItemRemove: ", data)
	}

	onPlayerChat(data) {
		console.log("onPlayerChat: ", data)
	}

	onPlayerMove(data) {
		console.log("onPlayerMove: ", data)
	}

	onPlayerAnimation(data) {
		console.log("onPlayerAnimation: ", data)
	}

	onPlayerMotionCapture(data) {
		console.log("onPlayerMotionCapture: ", data)
	}

	destroy() {
		this.getConnectionManager().disconnect()
	}
}
